"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rebateInviteUserList = exports.useCommissionRebates = exports.useBoundShareCodeInfo = exports.createShareCode = exports.updateShareCode = exports.useShareCodeList = exports.useInviteUserList = exports.useInviteLinkList = exports.useRebateHistory = exports.useRebateStat = exports.useRebateBaseFull = exports.PAGESIZE = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const api_1 = require("../api/api");
exports.PAGESIZE = 10;
function useRebateBaseFull() {
    const [baseInfo, setBaseInfo] = (0, react_1.useState)(undefined);
    const [levelInfo, setLevelInfo] = (0, react_1.useState)(undefined);
    const [maxRate, setMaxRate] = (0, react_1.useState)({ spot_rate: 0, prep_rate: 0, swapx_rate: 0 });
    const [loading, setLoading] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setLoading(true);
        (0, trade_utils_lib_1.requestWithRetry)(() => (0, api_1.RebateApi)().rebateBaseFullGet(), {
            name: "rebateBaseFullGet",
            maxRetryCount: 3,
        }).subscribe({
            next: (res) => {
                setLoading(false);
                setBaseInfo(res.basic_info);
                setLevelInfo(res.rebate_level);
                setMaxRate(res.max_cashback_rate);
            },
            error: (error) => {
                setLoading(false);
                console.log(JSON.stringify(error));
            },
        });
    }, []);
    return (0, react_1.useMemo)(() => {
        return {
            loading,
            baseInfo,
            levelInfo,
            maxRate,
        };
    }, [baseInfo, levelInfo, loading, maxRate]);
}
exports.useRebateBaseFull = useRebateBaseFull;
function useRebateStat() {
    const [statInfo, setStatInfo] = (0, react_1.useState)(undefined);
    const [loading, setLoading] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setLoading(true);
        (0, trade_utils_lib_1.requestWithRetry)(() => (0, api_1.RebateApi)().rebateStatGet(), {
            name: "rebateStatGet",
            maxRetryCount: 3,
        }).subscribe({
            next: (res) => {
                setLoading(false);
                setStatInfo(res.rebate_stat);
            },
            error: (error) => {
                setLoading(false);
                console.log(JSON.stringify(error));
            },
        });
    }, []);
    return (0, react_1.useMemo)(() => {
        return {
            loading,
            statInfo,
        };
    }, [loading, statInfo]);
}
exports.useRebateStat = useRebateStat;
function useRebateHistory(start, end) {
    const [history, setHistory] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setLoading(true);
        (0, trade_utils_lib_1.requestWithRetry)(() => (0, api_1.RebateApi)().rebateHistoryGet({
            start_time: start,
            end_time: end,
        }), {
            name: "rebateHistoryGet",
            maxRetryCount: 3,
        }).subscribe({
            next: ({ list }) => {
                setLoading(false);
                setHistory(list !== null && list !== void 0 ? list : []);
            },
            error: (error) => {
                setLoading(false);
                console.log(JSON.stringify(error));
            },
        });
    }, [end, start]);
    return (0, react_1.useMemo)(() => {
        return {
            loading,
            history,
        };
    }, [history, loading]);
}
exports.useRebateHistory = useRebateHistory;
function useInviteLinkList() {
    const [linkList, setLinkList] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setLoading(true);
        (0, trade_utils_lib_1.requestWithRetry)(() => (0, api_1.RebateApi)().rebateInviteLinkListGet(), {
            name: "rebateInviteLinkListGet",
            maxRetryCount: 3,
        }).subscribe({
            next: ({ list }) => {
                setLoading(false);
                setLinkList(list !== null && list !== void 0 ? list : []);
            },
            error: (error) => {
                setLoading(false);
                console.log(JSON.stringify(error));
            },
        });
    }, []);
    return (0, react_1.useMemo)(() => {
        return {
            loading,
            linkList,
        };
    }, [linkList, loading]);
}
exports.useInviteLinkList = useInviteLinkList;
function useInviteUserList(page) {
    const [currentPage, setCurrentPage] = (0, react_1.useState)(page);
    const [userList, setUserList] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [pageTotal, setPageTotal] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        setLoading(true);
        (0, trade_utils_lib_1.requestWithRetry)(() => (0, api_1.RebateApi)().rebateInviteUserListGet({ page: currentPage, page_size: exports.PAGESIZE }), {
            name: "rebateInviteUserListGet",
            maxRetryCount: 3,
        }).subscribe({
            next: ({ list, total }) => {
                setLoading(false);
                setUserList(list !== null && list !== void 0 ? list : []);
                setPageTotal(total);
            },
            error: (error) => {
                setLoading(false);
                console.log(JSON.stringify(error));
            },
        });
    }, [currentPage]);
    return (0, react_1.useMemo)(() => {
        return {
            loading,
            userList,
            onPageChange: setCurrentPage,
            pageTotal,
        };
    }, [loading, pageTotal, userList]);
}
exports.useInviteUserList = useInviteUserList;
function useShareCodeList() {
    const [shareCodeList, setShareCodeList] = (0, react_1.useState)([]);
    const [defaultShareCode, setDefaultShareCode] = (0, react_1.useState)(undefined);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [refreshing, setRefreshing] = (0, react_1.useState)(false);
    const [errorMsg, setErrorMsg] = (0, react_1.useState)();
    const api = (0, api_1.RebateApi)();
    const updateList = (0, react_1.useCallback)(() => {
        setRefreshing(true);
        (0, trade_utils_lib_1.requestWithRetry)(() => api.shareCodeListGet(), {
            name: "shareCodeListGet",
            maxRetryCount: 3,
        })
            .pipe((0, operators_1.mergeMap)(({ list }) => {
            const defaultCode = list.filter((item) => Number(item.default) === 1)[0];
            const sortList = [defaultCode, ...list.filter((item) => Number(item.default) !== 1)];
            return (0, rxjs_1.of)({ list: sortList, defaultCode });
        }))
            .subscribe({
            next: ({ list, defaultCode }) => {
                setRefreshing(false);
                setShareCodeList(list !== null && list !== void 0 ? list : []);
                setErrorMsg(undefined);
                if (defaultCode) {
                    setDefaultShareCode(defaultCode);
                }
            },
            error: (error) => {
                setErrorMsg(error);
                setRefreshing(false);
                console.log(JSON.stringify(error));
            },
        });
    }, []);
    (0, react_1.useEffect)(() => {
        updateList();
    }, []);
    return (0, react_1.useMemo)(() => {
        return {
            loading,
            shareCodeList,
            defaultShareCode,
            updateList,
            refreshing,
            errorMsg,
        };
    }, [shareCodeList, loading, defaultShareCode, updateList, refreshing, errorMsg]);
}
exports.useShareCodeList = useShareCodeList;
function updateShareCode(params) {
    return (0, api_1.RebateApi)().shareCodePut(params);
}
exports.updateShareCode = updateShareCode;
function createShareCode(params) {
    return (0, api_1.RebateApi)().createShareCodePost(params);
}
exports.createShareCode = createShareCode;
function useBoundShareCodeInfo() {
    const [shareInfo, setShareInfo] = (0, react_1.useState)(undefined);
    const [loading, setLoading] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setLoading(true);
        (0, trade_utils_lib_1.requestWithRetry)(() => (0, api_1.RebateApi)().boundShareCodeInfoGet(), {
            name: "boundShareCodeInfoGet",
            maxRetryCount: 3,
        }).subscribe({
            next: (res) => {
                setLoading(false);
                setShareInfo(res);
            },
            error: (error) => {
                setLoading(false);
                console.log(JSON.stringify(error));
            },
        });
    }, []);
    return (0, react_1.useMemo)(() => {
        return {
            loading,
            shareInfo,
        };
    }, [shareInfo, loading]);
}
exports.useBoundShareCodeInfo = useBoundShareCodeInfo;
function useCommissionRebates(type, limit) {
    const [nextPage, setNextPage] = (0, react_1.useState)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [data, setData] = (0, react_1.useState)([]);
    const nextPageRef = (0, react_1.useRef)();
    const currentPageRef = (0, react_1.useRef)();
    const [hasMore, setHasMore] = (0, react_1.useState)(true);
    const isRefreshRef = (0, react_1.useRef)(false);
    const cachedDataRef = (0, react_1.useRef)([]);
    (0, react_1.useEffect)(() => {
        setLoading(true);
        const currentPageToken = nextPage;
        (0, trade_utils_lib_1.requestWithRetry)(() => (0, api_1.RebateApi)().commissionRebatesGet({ commission_type: type, next_page_token: nextPage, limit: limit }), {
            name: "commissionRebatesGet",
            maxRetryCount: 3,
        }).subscribe({
            next: ({ rebates, next_page_token }) => {
                setLoading(false);
                isRefreshRef.current = false;
                currentPageRef.current = currentPageToken;
                nextPageRef.current = next_page_token;
                if (!next_page_token) {
                    setHasMore(false);
                }
                const newData = [...cachedDataRef.current, ...(rebates !== null && rebates !== void 0 ? rebates : [])];
                cachedDataRef.current = newData;
                setData(newData);
            },
            error: (error) => {
                setLoading(false);
                isRefreshRef.current = false;
                console.log(JSON.stringify(error));
            },
        });
    }, [limit, nextPage, type]);
    const loadMore = (0, react_1.useCallback)(() => {
        if (currentPageRef.current === nextPage && nextPageRef.current && !isRefreshRef.current) {
            setNextPage(nextPageRef.current);
        }
    }, [nextPage]);
    const refresh = (0, react_1.useCallback)(() => {
        isRefreshRef.current = true;
        setNextPage(Math.random().toString());
        currentPageRef.current = undefined;
        setHasMore(false);
        nextPageRef.current = undefined;
        cachedDataRef.current = [];
    }, []);
    return (0, react_1.useMemo)(() => {
        return {
            loading,
            data,
            loadMore,
            hasMore,
            refresh,
            refreshing: isRefreshRef.current,
        };
    }, [data, hasMore, loadMore, loading, refresh]);
}
exports.useCommissionRebates = useCommissionRebates;
function rebateInviteUserList(pageIndex, pageSize) {
    return (0, api_1.RebateApi)().rebateInviteUserListGet({ page: pageIndex, page_size: pageSize !== null && pageSize !== void 0 ? pageSize : exports.PAGESIZE });
}
exports.rebateInviteUserList = rebateInviteUserList;
